import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useGetSectors } from '@/hooks/useGetSectors';
import { SelectOptions } from '@/components/ui/SelectOptions';
import { FormItemWrapper } from '@/components/Settings/DataExtraction/styles';

const { useFormInstance, useWatch } = Form;

export function SectorFormItem(): JSX.Element {
	const form = useFormInstance();
	const organization_id = useWatch('organization_id');
	const company_id = useWatch('company_id');

	const { isLoading: isLoadingSectors, data: sectors = [] } = useGetSectors({
		organization_id,
		company_id
	});

	function handleOnChange(): void {
		form.resetFields(['line_id', 'workstation_id']);
	}

	const isDisabled = !organization_id || !company_id;
	const isLoading = !!organization_id && !!company_id && isLoadingSectors;

	return (
		<FormItemWrapper name="sector_id" label={I18n.get('Sector')} labelCol={{ span: 24 }}>
			<SelectOptions
				allowClear
				options={sectors}
				loading={isLoading}
				disabled={isDisabled}
				onChange={handleOnChange}
				placeholder={I18n.get('Sector')}
			/>
		</FormItemWrapper>
	);
}
